import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import FaceVerificationCameraWrapper from "../FaceVerification/FaceVerificationCameraWrapper";
import { ExamsDetailsTypes } from "../../interfaces/exams.interface";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type FaceRecognitionDialogProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  successCallback: () => void;
  examDetails: ExamsDetailsTypes;
};
const FaceRecognitionDialog: React.FC<FaceRecognitionDialogProps> = ({
  open,
  setOpen,
  successCallback,
  examDetails,
}) => {
  const handleClose = () => {
    setOpen(false);
  };
  // if (!open) return <></>;
  return (
    <React.Fragment>
      <Dialog fullScreen open={open} onClose={handleClose}>
        <FaceVerificationCameraWrapper
          open={open}
          setOpen={setOpen}
          examDetails={examDetails}
          successCallback={successCallback}
        />
      </Dialog>
    </React.Fragment>
  );
};

export default FaceRecognitionDialog;
